import * as React from "react";
import { useRef, useEffect, useContext } from "react";
import { Form, Formik } from "formik";
import styled from "styled-components";
import WidgetEditApplyAllChangesContext from "views/components/contexts/WidgetEditApplyAllChangesContext";
import PropagateDisableSubmissionState from "views/components/aggregationwizard/PropagateDisableSubmissionState";
import { updateWidgetAggregationElements } from "./AggregationWizard";
const StyledForm = styled(Form)`
  display: flex;
  width: 100%;
`;
const useBindApplyElementConfigurationChanges = (formRef, config) => {
  const { bindApplyElementConfigurationChanges } = useContext(WidgetEditApplyAllChangesContext);
  useEffect(() => {
    bindApplyElementConfigurationChanges(() => {
      if (formRef.current) {
        const { dirty, values, isValid } = formRef.current;
        if (dirty && isValid) {
          return updateWidgetAggregationElements(values, config);
        }
      }
      return void 0;
    });
  }, [formRef, bindApplyElementConfigurationChanges, config]);
};
const WidgetConfigForm = ({ children, onSubmit, initialValues, validate, config }) => {
  const formRef = useRef(null);
  useBindApplyElementConfigurationChanges(formRef, config);
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues,
      validate,
      enableReinitialize: true,
      innerRef: formRef,
      validateOnChange: true,
      validateOnMount: true,
      onSubmit
    },
    (...args) => /* @__PURE__ */ React.createElement(StyledForm, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(
      PropagateDisableSubmissionState,
      {
        formKey: "widget-config",
        disableSubmission: !args[0].isValid || args[0].isValidating || args[0].isSubmitting
      }
    ), typeof children === "function" ? children(...args) : children)
  );
};
export default WidgetConfigForm;
